export default function createMailToLink(email, params = {}) {
  const base = `mailto:${email}`;
  const arrayParams = Object.entries(params);

  if (!arrayParams.length) return base;

  let paramString = '?';

  Object.entries(params).forEach(([key, value]) => {
    paramString += `${key}=${value}&`;
  });

  return `${base}${paramString}`;
}
